import { JsonValueSchema } from 'notable-common';
import { FlowWithCreatedBySchema, FlowWithDefinitionsSchema, FlowWithRunCountSchema, } from '../flow/flow.js';
import { FlowBlockUnionSchema, flowBlockSchemasByType } from '../flowDefinition/blocks/union.js';
import { FlowEdgeSchema } from '../flowDefinition/edges/edges.js';
import { FlowDataSchema } from '../flowDefinition/flowData.js';
import { FlowDefinitionForListSchema, FlowDefinitionWithFlowBasicSchema, FlowDefinitionWithFlowSchema, } from '../flowDefinition/flowDefinition.js';
import { FlowRunListResponseSchema } from '../flowRun/list.js';
import { FlowRunBlockResponseSchema, FlowRunWithBlockShellsResponseSchema, GetFlowRunBlockResponseSchema, GetFlowRunResponseSchema, } from '../flowRun/response.js';
import { FlowRunSignalResponseSchema } from '../flowRun/signal.js';
import { FlowTriggersResponseSchema } from '../flowTrigger/schema.js';
/**
 * Every schema that flow-api gives a name to, keyed by that name.
 *
 * These are the names a caller sees: flow-api emits one OpenAPI component per entry, and a client
 * that wants the schema behind a name reads it here rather than pulling the component out of the
 * generated document. Naming them in one place is what keeps the two the same thing.
 *
 * The keys are deliberately not literal. Deriving them would need `flowBlockSchemasByType` to carry
 * its own key type, and the inferred type of 73 block schemas exceeds what TypeScript will
 * serialize (TS7056). Half-deriving them is worse than not: `satisfies` alone keeps the names
 * written out here but drops every block name, so `HumanTask` would fail to type-check against a
 * catalog that contains it. Values are still checked by the annotation.
 */
export const FLOW_API_SCHEMAS_BY_NAME = {
    FlowData: FlowDataSchema,
    FlowBlock: FlowBlockUnionSchema,
    FlowEdge: FlowEdgeSchema,
    FlowWithCreatedBy: FlowWithCreatedBySchema,
    FlowWithRunCount: FlowWithRunCountSchema,
    FlowWithDefinitions: FlowWithDefinitionsSchema,
    FlowDefinitionWithFlow: FlowDefinitionWithFlowSchema,
    FlowDefinitionWithFlowBasic: FlowDefinitionWithFlowBasicSchema,
    FlowDefinitionForList: FlowDefinitionForListSchema,
    JsonValue: JsonValueSchema,
    FlowRunBlock: FlowRunBlockResponseSchema,
    FlowRunWithBlockShells: FlowRunWithBlockShellsResponseSchema,
    GetFlowRun: GetFlowRunResponseSchema,
    GetFlowRunBlock: GetFlowRunBlockResponseSchema,
    FlowRunListResponse: FlowRunListResponseSchema,
    FlowRunSignal: FlowRunSignalResponseSchema,
    FlowTriggersResponse: FlowTriggersResponseSchema,
    ...flowBlockSchemasByType,
};
//# sourceMappingURL=schemas.js.map